"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchAccount = void 0;
const react_1 = __importStar(require("react"));
const classFunctions_1 = require("../../../../utils/classFunctions");
const Autocomplete_1 = require("../Autocomplete/Autocomplete");
const SearchAccountBadge_1 = require("./SearchAccountBadge");
const SearchAccountItem_1 = require("./SearchAccountItem");
const SearchAccount = (props) => {
    const { value, setValue, items, toItem, query = '', setQuery, placeholder, label, error, required, disabled, hidden, modificators, additionClassNames, } = props;
    const classNames = (0, classFunctions_1.getClassNames)('search-account', modificators, additionClassNames);
    const accountBadge = (0, react_1.useMemo)(() => {
        if (!value)
            return null;
        const mappedValue = toItem(value);
        const accountBadgeProps = {
            name: mappedValue.name,
            userType: mappedValue.userType,
            onCloseClick: () => setValue === null || setValue === void 0 ? void 0 : setValue(undefined),
            disabled,
        };
        return react_1.default.createElement(SearchAccountBadge_1.SearchAccountBadge, { ...accountBadgeProps });
    }, [value, setValue, disabled, toItem]);
    const onChangeHandler = (0, react_1.useCallback)((e) => {
        setQuery === null || setQuery === void 0 ? void 0 : setQuery(e.target.value);
    }, [setQuery]);
    if (hidden)
        return null;
    return (react_1.default.createElement(Autocomplete_1.Autocomplete, { label: label, error: error, placeholder: placeholder, required: required, disabled: disabled, className: classNames, onChange: onChangeHandler, value: query, addon: accountBadge, addonWidth: '200px' }, items === null || items === void 0 ? void 0 : items.map((item) => {
        const mappedItem = toItem(item);
        return (react_1.default.createElement(SearchAccountItem_1.SearchAccountItem, { ...mappedItem, key: mappedItem.id, onClick: () => {
                setValue === null || setValue === void 0 ? void 0 : setValue(item);
            } }));
    })));
};
exports.SearchAccount = SearchAccount;
//# sourceMappingURL=index.js.map